import FormImagesSwiper from 'components/FormImagesSwiper/FormImagesSwiper';
import {
  StickyContainer,
  SmallFormImagesWrapper,
  SwiperWrapper,
  FormImagesContainer,
} from './FormImages.styled';
import { IImageSection } from './hooks';
import { useState } from 'react';
import { getSmallImageIndices } from './helpers';
import SmallFormImage from 'components/SmallFormImage/SmallFormImage';
import { PreviewImageModal } from 'components/Modals/PreviewImageModal/PreviewImageModal';

interface IFormImagesProps {
  visibleImages: IImageSection[];
  singleImage?: boolean;
  disableSticky?: boolean;
}

const FormImages = ({
  visibleImages,
  singleImage,
  disableSticky,
}: IFormImagesProps) => {
  const [isPreviewImageModalOpen, setIsPreviewImageModalOpen] =
    useState<boolean>(false);
  const [previewImage, setPreviewImage] = useState<IImageSection | null>(null);

  const [activeSlide, setActiveSlide] = useState<number>(0);

  const smallImageIndices = getSmallImageIndices(
    activeSlide,
    visibleImages.length
  );

  return (
    <FormImagesContainer
      isVisible={visibleImages.length}
      singleImage={singleImage}
    >
      <StickyContainer disableSticky={disableSticky}>
        <SwiperWrapper>
          <FormImagesSwiper
            singleImage={singleImage}
            images={visibleImages}
            activeSlide={activeSlide}
            setActiveSlide={setActiveSlide}
            setPreviewImage={(image: IImageSection | null) => {
              setPreviewImage(image);
              setIsPreviewImageModalOpen(true);
            }}
          />
        </SwiperWrapper>
        {visibleImages.length && !singleImage ? (
          <SmallFormImagesWrapper>
            {smallImageIndices?.map((index: number) => (
              <SmallFormImage
                image={visibleImages[index]}
                key={index}
                onClick={() => setActiveSlide(index)}
                singleImage={singleImage}
              />
            ))}
          </SmallFormImagesWrapper>
        ) : null}
      </StickyContainer>
      <PreviewImageModal
        isOpen={isPreviewImageModalOpen}
        setIsOpen={setIsPreviewImageModalOpen}
        image={previewImage}
      />
    </FormImagesContainer>
  );
};

export default FormImages;
